var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38831 15.6995C4.19216 16.144 10.011 19.4983 14.1488 16.913C18.2864 14.3278 18.0582 9.87383 18.0582 7.83288C18.433 7.04764 19.2248 6.64844 19.2248 4.52297C18.447 5.24145 17.674 5.48591 16.9056 5.25637C16.1528 4.10862 15.1171 3.60098 13.7985 3.73345C11.8205 3.93216 11.0969 5.8727 11.3099 8.38328C8.26007 9.92555 5.86859 7.26527 4.63613 5.25637C4.22434 6.83847 3.82727 8.7379 4.63613 10.8391C5.17537 12.2399 6.47163 13.4242 8.52492 14.3919C6.44404 15.5198 4.73183 15.9556 3.38831 15.6995Z",
    fill: "#A99CEC",
    stroke: "#A99CEC",
    strokeWidth: 0.8335,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTwitterIcon);
export default __webpack_public_path__ + "static/media/mobile-twitter-icon.49b758bdfbbc792eaaeaea15943f004c.svg";
export { ForwardRef as ReactComponent };